import PropTypes from 'prop-types';
import React from 'react';
import FGBPurpleLogo from '../../Icons/Group/FGBPurpleLogo';
import GroupsHeading from '../../Icons/Group/GroupsHeading';

import Painter from '../../Icons/Group/Painter';

import './LanderHeader.scss';

export default class LanderHeader extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * number of fgb users
         */
        numberOfUsers: PropTypes.number.isRequired,
        /**
         * node of children, e.g. can be one button or two buttons
         */
        children: PropTypes.node,
    };

    static defaultProps = {
        children: null,
    };

    render() {
        return (
            <div className="component-Groups-LanderHeader">
                <a href="/groups">
                    <div className="icons">
                        <Painter />
                        <FGBPurpleLogo />
                        <GroupsHeading />
                    </div>
                </a>

                <div className="join-us-description">
                    Join <b>{this.props.numberOfUsers.toLocaleString()}</b>{' '}
                    other FGB'ers who support, listen and share what we know.
                </div>

                {this.props.children}
            </div>
        );
    }
}
